<div class="wrapper flex flex-col h-full">
  <div class="heading mb-[24px] flex flex-row justify-between items-center">
    <div class="counter text-type-2">
      Create new folder
    </div>
    <mat-icon (click)="close()">close</mat-icon>
  </div>

  <div class="details flex flex-col gap-[20px] flex-1 flex-grow">
    <app-text-input
      [controlName]="'name'"
      [label]="'name'"
      [parentFormGroup]="form"
      class="mb-[20px]"
    />
  </div>

  <div class="actions w-full flex flex-row gap-[20px]">
    <app-secondary-button (handleClick)="close()" class="w-1/2">Cancel</app-secondary-button>
    <app-primary-button (handleClick)="save()" class="w-1/2">Save</app-primary-button>
  </div>
</div>
